/* src/app/yes-no/yes-no.component.scss */
.yes-no {
  margin-bottom: 20px;
  display: flex;
}
.error {
  color: red;
  margin-left: 5px;
  padding-top: 11px;
  margin-left: 20px;
}
.options {
  display: flex;
  width: 120px;
  border-radius: 20px;
}
.options .option {
  flex: 1;
  padding: 10px 5px;
  text-align: center;
  border: 1px solid #555969;
}
.options .option:hover {
  cursor: pointer;
}
.options .option.selected {
  background: #555969;
  color: #6ccc09;
}
.options .option:first-child {
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.options .option:last-child {
  border-left: 0px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
}
/*# sourceMappingURL=yes-no.component.css.map */
